import { render, staticRenderFns } from "./BindsTable.vue?vue&type=template&id=54c5369a&"
import script from "./BindsTable.vue?vue&type=script&lang=js&"
export * from "./BindsTable.vue?vue&type=script&lang=js&"
import style0 from "./BindsTable.vue?vue&type=style&index=0&id=54c5369a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports